import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LgpdService {

  constructor(
    private http: HttpClient
  ) { }

  postLgpd(body: any) {
    return this.http.post(`${environment.protheus}/lgpd`, body);
  }
}
